import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "../firebase";
import { useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useNavigate } from "react-router-dom/dist";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton } from "@mui/material";
import Card from "@mui/material/Card";
import MonthlyReports from "./MonthlyReports";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { GridCloseIcon } from "@mui/x-data-grid";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#E8EAF6",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
});

export default function Dashboard(props) {
  const [rows, setRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState(false);
  const [filterMonth, setFilterMonth] = useState({});
  const [viewForm, setViewForm] = useState({});
  const months = [
    {
      name: "January",
      number: 1,
    },
    {
      name: "February",
      number: 2,
    },
    {
      name: "March",
      number: 3,
    },
    {
      name: "April",
      number: 4,
    },
    {
      name: "May",
      number: 5,
    },
    {
      name: "June",
      number: 6,
    },
    {
      name: "July",
      number: 7,
    },
    {
      name: "August",
      number: 8,
    },
    {
      name: "September",
      number: 9,
    },
    {
      name: "October",
      number: 10,
    },
    {
      name: "November",
      number: 11,
    },
    {
      name: "December",
      number: 12,
    },
  ];

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "products");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);

  const handleViewClose = () => {
    setView(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setVisible(true);
  };

  const handleReset = () => {
    setSearchTerm("");
    setVisible(false);
  };

  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: "#1f1966",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#1f1979",
    },
  }));

  const handleNav = () => {
    navigate("/add");
  };

  const filteredItems = rows.filter((item) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
  
    return searchTermLowerCase === "" || item.productName.toLowerCase().includes(searchTermLowerCase);
  });

  const ViewDialog = ({ rowData, onClose }) => {
    return (
      <div className="dialog-overlay" onClick={onClose}>
      
        <div className="view-card">
          <div className="view-wrapper">
            <div>
              <h3>{viewForm.productName}</h3>
            </div>
            <div className="view">
              <label htmlFor="pname">Product Id</label>
              <span>: </span>
              <span className="data">{viewForm.productId}</span>
              <label htmlFor="pname">Category</label>
              <span>: </span>
              <span className="data">{viewForm.category}</span>
              <label htmlFor="pname">Subject</label>
              <span>: </span>
              <span className="data">{viewForm.subject}</span>
              <label htmlFor="pname">Total Quantity</label>
              <span>: </span>
              <span className="data">{viewForm.quantity}</span>
              <label htmlFor="pname">Cost</label>
              <span>: </span>
              <span className="data">{viewForm.amount}</span>
              <label htmlFor="pname">Description</label>
              <span>: </span>
              <span className="data">{viewForm.description}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="home-container">
    <div className="head" style={{ height: "8vh", width: "200px" }}>
        <SearchIcon sx={{position:"absolute",zIndex:"10",left:"200px",top:"8px"}} />
        <input
          id="search"
          type="text"
          value={searchTerm}
          placeholder="Search..."
          onChange={handleSearch}
        />
        {/* {visible && (
          <IconButton
            className="reset"
            aria-label="delete"
            onClick={handleReset}
          >
            <RestartAltIcon />
          </IconButton>
        )} */}
      </div>
      {view && (
      <ViewDialog rowData={viewForm} onClose={() => setView(false)} />
    )}
      {/* <AddButton
          startIcon={<AddIcon />}
          onClick={handleNav}
          variant="contained"
          sx={{width: "200px", position:"relative", top:"-20px"}}
        >
          Add New
        </AddButton> */}
      {/* <SearchIcon className="search-icon" />
        <input
          id="search"
          type="text"
          value={searchTerm}
          placeholder="Search..."
          onChange={handleSearch}
        /> */}
      {/* {visible && (
          <IconButton
            className="reset"
            aria-label="delete"
            onClick={handleReset}
          >
            <RestartAltIcon />
          </IconButton>
        )} */}
      {/* <div style={{ position: "relative",top: "-40px", left: "120px" }}>
          <span style={{ color: "green" }}>Total Income</span>
          <span style={{ color: "green", position:"relative",left:"4.75px" }}> : </span>
          <span style={{ position: "relative", top: "1px",left:"4.5px" }}>
            {totalIncome}
          </span>
          <br></br>
          <span style={{ color: "red" }}>Total Expense</span>
          <span style={{ color: "red" }}> : </span>
          <span style={{ position: "relative", top: "1px" }}>
            {totalExpense}
          </span>
        </div> */}
      <Card sx={{ background: "transparent", boxShadow: "none" }}>
        <div style={{ width: "10%" }}>
          <span>Id</span>
        </div>
        <div style={{ width: "20%" }}>
          <span>Name</span>
        </div>
        {/* <div style={{ width: "20%" }}>
          <span>Category</span>
        </div>
        <div style={{ width: "15%" }}>
          <span>Subject</span>
        </div> */}
        <div style={{ width: "30%" }}>
          <span>Quantity</span>
        </div>
        <div style={{ width: "20%", textAlign: "center" }}>
          <span>Actions</span>
        </div>
      </Card>
      {filteredItems.map((i) => {
        return (
          <Card key={i.id}>
            <div style={{ width: "10%", fontWeight: "500" }}>
              <span>{i.productId}</span>
            </div>
            <div style={{ width: "20%", fontWeight: "500" }}>
              <span>{i.productName}</span>
            </div>
            {/* <div style={{ width: "20%", fontWeight: "500" }}>
              <span>{i.category}</span>
            </div>
            <div style={{ width: "15%", fontWeight: "500" }}>
              <span>{i.subject}</span>
            </div> */}
            <div style={{ width: "30%", fontWeight: "500" }}>
              <span>{i.quantity}</span>
            </div>
            <div
              style={{ width: "20%", textAlign: "center", color: "blue" }}
              // onClick={() => {
              //   navigate(`/reports/${i.id}`);
              // }}
              onClick={() => {
                setViewForm(i);
                setView(true);
              }}
            >
              <span>
                <VisibilityIcon />
              </span>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
